import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ease } from "./motion";

const LINES = [
  "resolving lunar-ns.com",
  "bgp session established",
  "vlan 10 · 20 · 30 up",
  "firewall policy loaded",
  "uplink ready",
];

export const Loader = ({ onDone }) => {
  const [n, setN] = useState(0);

  useEffect(() => {
    let v = 0;
    const id = setInterval(() => {
      v = Math.min(100, v + Math.ceil(Math.random() * 8) + 2);
      setN(v);
      if (v >= 100) {
        clearInterval(id);
        setTimeout(onDone, 380);
      }
    }, 55);
    return () => clearInterval(id);
  }, [onDone]);

  const shown = Math.ceil((n / 100) * LINES.length);

  return (
    <motion.div
      data-testid="boot-loader"
      className="fixed inset-0 z-[100] bg-void flex flex-col justify-between p-6 sm:p-10"
      exit={{ clipPath: "inset(0 0 100% 0)" }}
      initial={{ clipPath: "inset(0 0 0% 0)" }}
      transition={{ duration: 1, ease }}
    >
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">Lunar Network Solutions / boot</div>
      <div className="font-mono text-xs sm:text-sm text-slate-400 space-y-1.5">
        {LINES.slice(0, shown).map((l) => (
          <p key={l}>
            <span className="text-cyan-300">&gt;</span> {l} <span className="text-emerald-400">ok</span>
          </p>
        ))}
      </div>
      <div className="flex items-end justify-between">
        <div className="h-px flex-1 mr-6 bg-white/10 relative overflow-hidden">
          <div className="absolute inset-y-0 left-0 bg-cyan-300" style={{ width: `${n}%` }} />
        </div>
        <span className="font-display font-extrabold text-6xl sm:text-8xl tabular-nums leading-none">{n}</span>
      </div>
    </motion.div>
  );
};
